import { ProgramSessionSetControllerApi, SetControllerApi } from "src/api/api";

export interface IWorkoutSessionSetApiClients {
    workoutSessionSet: ProgramSessionSetControllerApi;
}

export class WorkoutSessionSetApiClients {
    private static instance: IWorkoutSessionSetApiClients;

    private constructor() { }

    static getInstance(basePath: string): IWorkoutSessionSetApiClients {
        if (WorkoutSessionSetApiClients.instance == null) {
            WorkoutSessionSetApiClients.instance = {
                workoutSessionSet: new ProgramSessionSetControllerApi({
                    basePath: basePath,
                    isJsonMime() {
                        return true;
                    }
                }),
            };
        }
        return WorkoutSessionSetApiClients.instance;
    }
}